// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

/*获取全局变更，并将其放入原型链中*/
import globalVar from '@/api/global_variable'
Vue.prototype.GLOBAL=globalVar


//路由拦截
router.beforeEach((to,from,next)=>{
	if(to.meta.title){
		 document.title = to.meta.title;
	}
	//切换显示PC端口提示  start
	if(!globalVar.isWeiApp() && to.path==='/Vrbox' ){
		next('/home');
		return;
	}
	if(!globalVar.isWeiApp() && to.path==='/vrbox'){
		next('/home');
		return;
	}

	if(globalVar.isWeiApp() && to.path==='/home'){
		next('/vrbox');
		return;
	}
	

	//切换显示PC端口提示  end
	let udateStr=localStorage.getItem('udata');
	let udata=JSON.parse(udateStr);
	if(to.path==='/vrbox' && udateStr==null){
		//console.log("未登录状态");
		next('/Oauth');
		//next();
	}else if(to.path==='/vrbox' && udateStr != null){
		//console.log('已获取用户数据');
		//console.log(udata);
		next();
	}else{
		next();
	}
	//console.log(to);
	//console.log(from);
})



import animated from 'animate.css'
Vue.use(animated)


/*Van组件引用*/
import {Toast,Loading} from 'vant';
Vue.use(Loading).use(Toast);

/*import { Swipe, SwipeItem,Loading,Lazyload,List,Field,Picker,Cell, CellGroup,Uploader,Toast} from 'vant';
Vue.use(Swipe).use(SwipeItem).use(Loading).use(Lazyload).use(List).use(Field).use(Picker).use(Cell).use(CellGroup).use(Uploader).use(Toast);*/

/*swiper组件引用*/
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';


Vue.config.productionTip = false
Vue.prototype.$axios = axios
/*axios.defaults.baseURL = "/api"; */
axios.defaults.baseURL = globalVar.baseURL; 
axios.defaults.headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
}

/*Jsonp组件引用*/
/*import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)*/

/*引入资源请求插件*/
/*import VueResource from 'vue-resource'*/
/*使用VueResource插件*/
/*Vue.use(VueResource)*/
import  "../static/js/util.js"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})






// WEBPACK FOOTER //
// ./src/main.js